export const lang = {
  "en": "English",
  "th": "Thai"
};
